import React, { useState, useEffect, useRef, version, useCallback } from 'react'
import {Form, Button, DropdownButton, Dropdown, ProgressBar, Check, Modal, Tabs, Tab} from "react-bootstrap";
import axios from 'axios';
import * as signalR from "@microsoft/signalr";
import { Container } from 'reactstrap';
import '../account/Drones.css';
import {useTranslation} from "react-i18next";
import i18n from "../../i18n";
import ModemMainP from "../account/ModemMainP";
import './ModemSettings.css';
import MainSettings from './settings/MainSettings';
import OGNSettings from './settings/OGNSettings';
import NebosvodSettings from './settings/NebosvodSettings';

function ModemSettings({drone, isNebosvodAuth, nebosvodAuthLogin, onNebosvodAuth}){
    const { t } = useTranslation(['modem']);
    const protocol = new signalR.JsonHubProtocol();
    const transport = signalR.HttpTransportType.WebSockets;

    const [hubTest, setHubTest] = useState(hubConnect);
    
    //const [isNebosvodAuth, setIsNebosvodAuth] = useState(isNebosvodAuth)

    
    

    const [activeTab, setActiveTab] = useState("settings");

    const [isOnline, setIsOnline] = useState(false);
    const imei = useRef("");

    useEffect(() => {
        console.log("Компонент отрендерился!");
      }, [drone, isNebosvodAuth, nebosvodAuthLogin, onNebosvodAuth]);
    
    
    function hubConnect(){
        let connection = new signalR.HubConnectionBuilder()
            .withUrl("api/drone-hub")
            .withAutomaticReconnect([0, 2000, 10000, 10000, 30000, 10000])
            .withHubProtocol(protocol)
            .build();;
        
        connection.on('SetOnline', (message) => {
            setIsOnline(message.isOnline);
        });
        connection.start();
        return connection;
    }

    useEffect(() => {
        return () => {
            console.log("modem.js unmount");
            hubTest.stop();
        };
    }, []);

    useEffect(() => {
        console.log("drone remount");
        
        setIsOnline(drone.isOnline)
        imei.current = drone.imei;
    }, [drone]);

    const MenuButton = useCallback(({tabName, activeImgSrc, inactiveImgSrc}) => {
        return (
            <div className='menu-button' onClick={() => setActiveTab(tabName)}>
                <img className='menu-icon' src={activeTab === tabName ? activeImgSrc : inactiveImgSrc}/>
            </div>
        )
    }, [activeTab]);

    return(
        <>
            <div className='modem-settings'>
                <div className='modem-settings-menu'>
                    <MenuButton tabName="settings" activeImgSrc="/image/menu/settings_on.svg" inactiveImgSrc="/image/menu/settings.svg"/>
                    {/*<MenuButton tabName="modem" activeImgSrc="/image/menu/home_on.svg" inactiveImgSrc="/image/menu/home.svg"/>*/}
                    <MenuButton tabName="ogn" activeImgSrc="/image/menu/ogn_on.svg" inactiveImgSrc="/image/menu/ogn.svg"/>
                    <MenuButton tabName="nebosvod" activeImgSrc="/image/menu/nebosvod_on.svg" inactiveImgSrc="/image/menu/nebosvod.svg"/>
                </div>
                <div className='menu-separator'><img className='menu-separator-img' src="/image/menu/separator.svg"/></div>
                <div>
                    <div className='modem-settings-label'>
                        <div>
                            {activeTab === "modem" && t('main_page')}
                            {activeTab === "ogn" && "OGN/FlightRadar"}
                            {activeTab === "nebosvod" && "Небосвод"}
                            {activeTab === "settings" && t('settings')}
                        </div>
                    </div>
                    <div className='settings-tab'>
                        {activeTab === "settings" && <MainSettings drone={drone}/>}
                        {activeTab === "modem" && <ModemMainP drone={drone}/>}
                        {activeTab === "ogn" && <OGNSettings drone={drone}/>}
                        {activeTab === "nebosvod" && <NebosvodSettings drone={drone} isNebosvodAuth={isNebosvodAuth} nebosvodAuthLogin={nebosvodAuthLogin} onNebosvodAuth={onNebosvodAuth}/>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModemSettings;